import { render, staticRenderFns } from "./SectionUpload.vue?vue&type=template&id=34266e80&scoped=true&"
import script from "./SectionUpload.vue?vue&type=script&lang=ts&"
export * from "./SectionUpload.vue?vue&type=script&lang=ts&"
import style0 from "./SectionUpload.vue?vue&type=style&index=0&id=34266e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34266e80",
  null
  
)

export default component.exports